<div ngbDropdown
     class="language-selector-dropdown"
     [placement]="'bottom-right'">
  <button class="language-selector-btn font-md pointer" ngbDropdownToggle>
    {{activeCode.label | translate}}
  </button>
  <div class="dropdown-menu py-0" ngbDropdownMenu>
    <ng-container *ngFor="let code of codes;">
      <button class="dropdown-item font-md"
              *ngIf="code.value !== activeCode.value"
              (click)="changeLanguage(code.value)">
        {{code.label | translate}}
      </button>
    </ng-container>
  </div>
</div>
